import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class MigrationPopupService {
  intervalId: any;
  constructor() {
  }


   startPopupCheck(popupInterval, storageKey, checkInterval): void {
    this.intervalId = setInterval(() => {
      const lastShown = Number(localStorage.getItem(storageKey)) || 0;
      const currentTime = Date.now();
      if (currentTime - lastShown >= popupInterval) {
        this.showPopup(storageKey);
      }
    }, checkInterval);
  }

  showPopup(storageKey): void {
    // Save current timestamp in localStorage
    localStorage.setItem(storageKey, Date.now().toString());

    // Trigger a popup display event (you can use an observable for this)
    const event = new CustomEvent('showPopup');
    window.dispatchEvent(event);
  }

  stopPopupCheck(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }


}
